import React, { useContext, useState } from "react";
import { get, parseInt, isEmpty } from "lodash";
import { OverlayTrigger, Tooltip, Row, Col, Form } from "react-bootstrap";
import {
  GetInitials,
  EditActionSlider,
  AddTreeStructure,
  SliderPanel,
  LoaderWrapper,
  ManageDistributionLayoutNew,
  EmployeeDetailsCard,
  ManageTransactionLayout,
  RejectRequestModal,
} from "../../../components";
import {
  FLOW_TYPES,
  getAdvancedPathWithParam,
  getCommaSeparatedValuesFromArr,
  getDateWithSlash,
  getFormattedSsn,
  getNullTableItem,
  getPathWithParam,
  MANAGE_CENSUS_ROUTES,
  ROUTES,
  ssnMasking,
  getWithdrawalName,
  MANAGE_TRANSACTION_ROUTES,
  MANAGE_DISTRIBUTION_ROUTES,
  MANAGE_COMPANY_ROUTES,
  manageDistributionFormNames,
  distributionFormFields,
  OPTIONS_DATA_MAPPER,
} from "../../../utils";
import AddToolTip from "../../../components/AddToolTip";
// import employeeImage from "../../../assets/sample_image.png";

import { EmployeeStatus } from "../../../layouts";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import {
  getEmployeeImage,
  getCompanyLogo,
  getWithdrawalRequest,
  getBalances,
  approvalWithdrawalRequest,
  submitWithdrawalRequest,
  getEmployeePlanWithdrawals,
  getEmployeeCensusInformation,
} from "../../../services";
import { Link, useHistory } from "react-router-dom";
import ManageDistributionLayout from "../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { Formik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import {
  appLayoutStore,
  manageDistributionStore,
  manageTransactionStore,
  setManageDistributionToastInfo,
  setWithdrawalRequestPageData,
} from "../../../contexts";
import {
  faExclamationCircle,
  faInfoCircle,
  faCheckCircle,
  faTimesCircle,
  faPrint,
} from "@fortawesome/pro-light-svg-icons";
import PayeeDetailsCard from "../../../components/PayeeDetailsCard/PayeeDetailsCard";
import { setManageTransactionToastInfo } from "./../../../contexts/reducers/manage-transaction/actions";
import { globalToastInfo } from "./../../../contexts/reducers/app-layout/actions";
import WithdrawalSummaryComponent from "../../Distribution/WithdrawalSummaryContainer/WithdrawalSummaryComponent";

const initialValues = {};
const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
const fields = distributionFormFields[formName];

const WithdrawalRequestPendingApprovalContainer = (props) => {
  const ApproveRejectApi = (aproveOrReject, Reason, callBack) => {
    setResponseLoading(true);
    approvalWithdrawalRequest({
      userId: 1,
      withdrawalrequestId: withdrawalRequestId,
      //responseModel?.approveWithdrawalRequests.withdrawalRequestId,
      userRole: 1,
      approval: aproveOrReject,
    })
      .then((response) => {
        setResponseLoading(false);
        callBack();
        dispatch2(
          setManageTransactionToastInfo({
            showToast: true,
            toastMessage: "Withdrawal request is approved successfully",
            toastMessage2: empName,
            toastMessage1: "Withdrawal amount" + " " + totalRequestAmount,
          })
        );
        history.push(
          getPathWithParam({
            path: `${MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL}`,
          })
        );
      })
      .catch((ex) => {
        setResponseLoading(false);
      });
  };
  const RejectApi = (aproveOrReject, Reason, callBack) => {
    // setLoading(true);
    approvalWithdrawalRequest({
      userId: 1,
      withdrawalrequestId: withdrawalRequestId,
      //responseModel?.approveWithdrawalRequests.withdrawalRequestId,
      userRole: 1,
      approval: aproveOrReject,
    })
      .then((response) => {
        callBack();
        // dispatch3(
        //   globalToastInfo({
        //     showToast: true,
        //     toastMessage: "Withdrawal request is approved successfully",
        //    // toastMessage2: empName,
        //     // toastMessage1: "Rolloverin amount" + " " + amount,
        //   })
        // );
        // history.push(
        //   getAdvancedPathWithParam({
        //     path: MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL,
        //   })
        // );
      })
      .catch((ex) => {});
  };
  const [show, setShow] = useState(false);
  const { state, dispatch } = useContext(manageDistributionStore);
  const { state: state2, dispatch: dispatch2 } = useContext(appLayoutStore);
  const [moreInfoSlideOpen, setMoreInfoSlideOpen] = useState(false);
  const [empName, setEmpName] = useState(null);
  const data = get(state, "withdrawalRequestData", []);
  const history = useHistory();
  const { flow, censusId, withdrawalRequestId, fromPage } = useRouterParams();
  const [sliderOpen1, setSliderOpen1] = useState(false);
  const [employeeImage, setEmployeeImage] = useState("");
  const [responseModel, setResponseModel] = useState(data);
  const [responseLoading, setResponseLoading] = useState(false);

  const totalRequestAmount = responseModel?.withdrawalTransactions?.reduce(
    (a, object) => a + object.requestedAmount,
    0
  );

  const onFormSubmit = (values) => {
    submitWithdrawalRequest(withdrawalRequestId).then((response) => {
      // if (response && fromPage == 4) {
      //   dispatch(
      //     setManageDistributionToastInfo({
      //       showToast: true,
      //       toastMessage: "Request is Submitted",
      //       reject: true,
      //     })
      //   );

      //   history.push(
      //     getAdvancedPathWithParam({
      //       path: fromPage == 4 ? MANAGE_TRANSACTION_ROUTES.DRAFT : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
      //       pathParam: fromPage != 4 && censusId,
      //     })
      //   );
      // }
      if (response) {
        dispatch(
          setManageDistributionToastInfo({
            showToast: true,
            toastMessage: "Request submitted successfully",
          })
        );
        // history.push(
        //   getAdvancedPathWithParam({
        //     path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
        //     pathParam: censusId,
        //   })
        // );
        history.push(
          getAdvancedPathWithParam({
            path:
              fromPage == 4
                ? MANAGE_TRANSACTION_ROUTES.DRAFT
                : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
            pathParam: fromPage != 4 && censusId,
          })
        );
      }
    });
  };
  const buttons = [
    {
      request: 2,
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: getPathWithParam({
        path:
          fromPage == 1
            ? MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL
            : fromPage == 4
            ? MANAGE_TRANSACTION_ROUTES.DRAFT
            : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
        pathParam: fromPage == 1 ? [] : fromPage == 4 ? [] : censusId,
      }),
    },
    {
      request: 2,
      label: "Edit",
      variant: "secondary",
      type: "button",
      link: getPathWithParam({
        path: ROUTES.WITHDRAWAL_REQUEST,
        pathParam: [flow, censusId, withdrawalRequestId, 1],
        //responseModel?.approveWithdrawalRequests?.withdrawalRequestId,
      }),
    },
    {
      request: 2,
      label: "Reject",
      variant: "outline-danger",
      type: "button",
      onClick: () => {
        // ApproveRejectApi(false);
        setShow(true);
      },
    },
    {
      request: 2,
      label: "Approve",
      variant: "primary",
      type: "button",
      onClick: () => {
        // ApproveRejectApi(true);
        ApproveRejectApi(true, "", () => {});
        //onApproveClick();
      },
    },

    {
      request: 1,
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: getPathWithParam({
        path:
          fromPage == 1
            ? MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL
            : fromPage == 4
            ? MANAGE_TRANSACTION_ROUTES.DRAFT
            : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
        pathParam: fromPage == 1 ? [] : fromPage == 4 ? [] : censusId,
      }),
    },
    {
      request: 1,
      label: "Edit",
      variant: "secondary",
      type: "button",
      link: getPathWithParam({
        path: ROUTES.WITHDRAWAL_REQUEST,
        pathParam: [flow, censusId, withdrawalRequestId, 1],
        //responseModel?.approveWithdrawalRequests?.withdrawalRequestId,
      }),
    },
    {
      request: 1,
      label: "Reject",
      variant: "outline-danger",
      type: "button",
      onClick: () => {
        // ApproveRejectApi(false);
        setShow(true);
      },
    },
    {
      request: 1,
      label: "Approve",
      variant: "primary",
      type: "button",
      onClick: () => {
        // ApproveRejectApi(true);
        ApproveRejectApi(true, "", () => {});
        //onApproveClick();
      },
    },

    // {
    //   request: 1,
    //   label: "Submit",
    //   variant: "primary",
    //   type: "submit",
    // },
  ];

  useDeepEffect(
    () => {
      dispatch(
        setWithdrawalRequestPageData({
          formName: "censusId",
          fieldData: censusId,
        })
      );
    },
    [censusId],
    false
  );

  const [filteredValues, setFilteredValues] = useState({});

  useDeepEffect(() => {
    if (censusId) {
      getEmployeeCensusInformation(parseInt(censusId)).then((response) => {
        setFilteredValues(response);
      });
    }
  }, [censusId]);
  return (
    <LoaderWrapper isLoading={responseLoading} loaderText="">
      <Formik
        initialValues={{
          ...initialValues,
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          values,
          ...rest
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <ManageTransactionLayout
                withdrawalRequestId={withdrawalRequestId}
                buttons={
                  fromPage == 3
                    ? buttons.filter((x) => x.request == 3)
                    : responseModel?.withdrawalStatus == 1
                    ? buttons.filter((x) => x.request == 1)
                    : responseModel?.withdrawalStatus == 2
                    ? buttons.filter((x) => x.request == 2)
                    : null
                }
                layoutHeader="New Withdrawal Request"
                //filteredValues={filteredValues}
                isWithdrawalSummary={fromPage == 1 ? false : true}
                employeeImage={employeeImage}
                // employeeImage={employeeImage}
              >
                <div className="d-flex">
                  <WithdrawalSummaryComponent
                    responseModel={responseModel}
                    state={state}
                    setResponseModel={setResponseModel}
                    setResponseLoading={setResponseLoading}
                    filteredValues={filteredValues}
                    setSliderOpen1={setSliderOpen1}
                  />
                </div>
                <SliderPanel
                  isOpen={sliderOpen1}
                  size="35"
                  showCancel={false}
                  backdropClicked={() => setSliderOpen1(false)}
                >
                  <div className="disp-flex-col">
                    <div
                      className="disp-flex-row"
                      style={{
                        justifyContent: "space-between",
                        fontWeight: "500",
                        fontSize: "16px",
                        borderBottom: "1px solid #BDBDBD",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          marginBottom: "20px",
                        }}
                      >
                        Terms & Conditions
                      </p>
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => setSliderOpen1(false)}
                      />
                    </div>
                    <ul style={{ marginTop: "15px" }}>
                      <li>
                        I have read and understood all the rules governing
                        distributions/ rollover requests from my 401k plan.
                      </li>
                      <li>
                        I understand that funds may impose redemption fees on
                        certain transfers, redemptions or exchanges if assets
                        are held less than the period stated in the funds
                        prospectus or other disclosure documents.
                      </li>
                      <li>
                        I understand that it is entirely my responsibility to
                        ensure that this election conforms with all applicable
                        provisions of the Internal Revenue Code and that the
                        Plan into which I am rolling money over will accept the
                        dollars, if applicable.
                      </li>
                      <li>
                        I understand that I am liable for any income tax and/or
                        penalties assessed by the IRS for any election I have
                        chosen.
                      </li>
                      <li>
                        I understand that once my payment has been processed, it
                        cannot be changed.
                      </li>
                    </ul>
                  </div>
                </SliderPanel>
              </ManageTransactionLayout>
              <RejectRequestModal
                show={show}
                setShow={setShow}
                totalRequestAmount={totalRequestAmount}
                history={history}
                // amount={amount}
                RejectApi={RejectApi}
                empName={empName}
              />
            </Form>
          );
        }}
      </Formik>
    </LoaderWrapper>
  );
};
export default WithdrawalRequestPendingApprovalContainer;
